var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _vm.sidebar.opened
            ? _c(
                "div",
                { staticClass: "pt-15 pl-10 pr-5", on: { click: _vm.renewal } },
                [
                  _c(
                    "div",
                    { staticClass: "flex align-center " },
                    [
                      _c(
                        "el-avatar",
                        { attrs: { size: 40, src: _vm.agentInfo.avatar } },
                        [
                          _c("img", {
                            attrs: { src: "", width: "40", height: "50" },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-cut flex1 pl-5" }, [
                        _c("div", { staticClass: "text-cut fs-c" }, [
                          _vm._v(_vm._s(_vm.agentInfo.name)),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "fs-s1 text-gray" }, [
                          _vm._v(_vm._s(_vm.agentInfo.agent_name)),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.contractInfo.date_type > 0
                    ? _c(
                        "div",
                        { staticClass: "mt-5 fs-s1 cursor text-center" },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "radius-15",
                              attrs: { type: "danger", size: "mini" },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.parseTime(
                                    _vm.contractInfo.end_date,
                                    "{y}-{m}-{d}"
                                  )
                                ) + "到期"
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-menu",
            {
              attrs: {
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "text-color": _vm.variables.menuText,
                "unique-opened": false,
                "active-text-color": _vm.variables.menuActiveText,
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            _vm._l(_vm.permission_routes, function (route) {
              return _c("sidebar-item", {
                key: route.path,
                attrs: { item: route, "base-path": route.path },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              "您好！账户" +
              (_vm.contractInfo.renewalStatus == 1
                ? "已到期，请及时续费"
                : _vm.contractInfo.renewalStatus == 2
                ? "即将到期，请及时续费"
                : "正常"),
            visible: _vm.renewalDialog,
            width: "660px",
            "modal-append-to-body": false,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": _vm.contractInfo.renewalStatus != 1,
          },
          on: {
            "update:visible": function ($event) {
              _vm.renewalDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "renewal-box" },
            [
              _c(
                "div",
                { staticClass: "flex flex-wrap justify-around" },
                _vm._l(_vm.moneyArr, function (item) {
                  return (item.contract_type == 2 &&
                    _vm.contractInfo.date_type == 2) ||
                    item.contract_type != 2
                    ? _c(
                        "div",
                        {
                          staticClass: "p-30 money-item radius-10 rel cursor",
                          class: {
                            act: item.contract_type == _vm.contract_type,
                          },
                          on: {
                            click: function ($event) {
                              _vm.contract_type = item.contract_type
                              _vm.renewal()
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "abs title fs-s2 text-white" },
                            [_vm._v(_vm._s(item.title))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-red f-w" }, [
                            _vm._v("￥"),
                            _c("span", { staticClass: "fs-b5" }, [
                              _vm._v(_vm._s(item.service_price)),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-5 b-line" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "fs-s2 text-primary" }, [
                            _vm._v(_vm._s(item.introduce)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "abs check" }, [
                            _c("span", { staticClass: "el-icon-check" }),
                          ]),
                        ]
                      )
                    : _vm._e()
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "l-t mt-40 pt-40 flex flex-wrap justify-around text-center",
                },
                [
                  _c("div", [
                    _c("div", { staticClass: "p-10 qrcode-box" }, [
                      _c("div", { attrs: { id: "qrcode" } }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-10 mb-10 text-wx" }, [
                      _c("i", { staticClass: "iconfont icon-weixinzhifu" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("微信支付")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fs-s2 text-red" }, [
                      _c("span", [_vm._v("打开微信(扫一扫)")]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("div", { staticClass: "p-10 qrcode-box ali" }, [
                      _c("div", { attrs: { id: "qrcode_ali" } }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mt-10 mb-10 text-ali" }, [
                      _c("i", {
                        staticClass: "iconfont icon-iconfontrectangle390",
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v("支付宝支付")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "fs-s2 text-red" }, [
                      _c("span", [_vm._v("打开支付宝(扫一扫)")]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm._l(_vm.moneyArr, function (item) {
                return item.contract_type == _vm.contract_type
                  ? _c(
                      "div",
                      { staticClass: "mt-40 fs-s2 text-gray text-center" },
                      [
                        _vm._v(
                          "提示：您选择" +
                            _vm._s(item.title) +
                            "，" +
                            _vm._s(
                              _vm.contract_type == 0
                                ? "账户永久有效"
                                : "账户到期时间：" + _vm.renewalInfo.expiry_date
                            )
                        ),
                      ]
                    )
                  : _vm._e()
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }